<template>
  <div class="Address">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
    />
  </div>
</template>

  <script>
  import FieldSet from '@/components/form/FieldSet.vue'

  import { required, helpers } from 'vuelidate/lib/validators'
  import { unicodeString } from '@/services/validation'

  import { mapGetters } from 'vuex'

  export default {
    name: 'StepOneMiscBottom',
    components: { FieldSet },
    props: {
      label: {
        type: String,
        default: '',
      },
      values: {
        type: Object,
        default: function() {
          return {}
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // Copied from Cafienne
        validation: {
          'ChargePointOperator': {
            required,
            unicodeString: (value) => !helpers.req(value) || unicodeString(value),
          },
        },
      }
    },
    computed: {
      ...mapGetters('tenant', [
        'isCurrentTenant',
      ]),
      /**
       * Disable if set and stored (record has a DB ref)
       */

      layout() {
        return [
          {
            'columns': '1fr',
            'fields': ['Remarks'],
          },
        ]
      },
      fields() {
        let fields = {
          'Remarks': {
              'type': 'string',
              'title': 'Toelichting bij het locatievoorstel',
              'format': 'textarea',
          },
        }

        return fields
      },
    },
  }
  </script>
